// extracted by mini-css-extract-plugin
var _1 = "CO44MzKuUQoxySNBXW8G";
var _2 = "j3S39DRxgBgr9woQC41M";
var _3 = "x232lTISucDPiEo5fLqs";
var _4 = "LmQqnAu9LObN4cnXu7xt";
var _5 = "ZLm2d3CL3dXvvaU0f20Y";
export { _1 as "forbiddenPage", _2 as "link", _3 as "messageContainer", _4 as "subtitle", _5 as "title" }
